import React from 'react'
import {Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import {Button} from 'semantic-ui-react'
import {MDBDataTable} from 'mdbreact'
import * as common from '../../../const/Common/CommonFunc';
import LabelDropdown from "../../../components/Dropdown/LabelDropdown/LabelDropdown";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_visitortag";
import axiosTags from "../../../axios/axios_tag";
import {Empty} from "antd";
import {DatePicker} from "antd";
import moment from "moment";
import '../../../react-antd.css'
import $ from "jquery";
import Download from '../../../components/Button/DownloadbleButton'
import apiConfig from "../../../axios/axios_api_services";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

class App extends React.Component {

  state = {
    totalVisits: "",
    totalVisitors: "",
    isTotal: false,
    visitors_list: [],
    spin: true,
    corporate_id: "",
    details: [],
    start_date: '',
    end_date: '',
    branchList: [],
    branch_id: '',type: "VISITOTAGS_CHECKIN", checkInType: "VISITOTAGS_CHECKIN"
  };

  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {
    } else {
      let start = new Date(dateString[0]).getTime();
      let end = new Date(dateString[1]).getTime();
      this.setState({
        start_date: start,
        end_date: end,
      });

      if (this.props.usr_obj.userRoles !== "SYS_ADMIN" && this.props.usr_obj.userRoles !== "CORP_ADMIN") {
        this.buttonHandler(start, end);
      }
    }
  };

  getAllBranch = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = id === undefined ? this.props.usr_obj.corporates[0].corporateId : id;
    axiosTags.get(apiConfig.CORPORATE_BRANCH(corporateId), {headers: headers})
      .then(async response => {
        if (response.data.success) {
          if (response.data.branchList.length !== 0) {

            let branchList = response.data.branchList;

            if (response.data.branchList.length > 1) {
              branchList = [{
                name: "ALL",
                branchId: 0
              }, ...branchList];
            }
            await this.setState({
              branchList: branchList,
              branch_id: branchList[0].branchId
            });
            this.buttonHandler();
          }
        } else {
          this.props.spinnerHandler(false);
          this.setState({branchList: [], branch_id: ''});
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch(id);
        } else {
          this.props.spinnerHandler(false);
        }
      })
  };

  getAllDetails = () => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.SERVICES, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if (response.data.body.length !== 0) {
            this.setState({
              corporate_id: response.data.body[0].corporateId,
              details: response.data.body,
            });
          }
        } else {
          this.setState({
            details: [],
            spin: false
          });
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDetails();
        }
      })
      .finally(fin => {
        this.getAllBranch();
      })
  };

  branchHandler = (e, {value}) => {
    this.setState({
      branch_id: value,
    })
  };

  corporateHandler = name => (e, {value}) => {
    if (name === "checkInType") {
      this.setState({
        [name]: value
      });
      return;
    }
    this.setState({
      [name]: value,
      branch_id: '',
    });
    this.getAllBranch(value);
  };

  buttonHandler = (start, end) => {

    let {corporate_id, start_date, end_date, branch_id, checkInType} = this.state;
    let condition = false;
    let startDate = new Date().setDate(new Date().getDate() - 30);
    let endDate = new Date().setDate(new Date().getDate());

    if (start === undefined && end === undefined) {
      if (start_date !== "" && end_date !== "") {
        startDate = start_date;
        endDate = end_date;
      }
    } else {
      startDate = start;
      endDate = end;
    }

    if (this.props.usr_obj.userRoles !== "SYS_ADMIN") {
      corporate_id = this.props.usr_obj.corporates[0].corporateId
    }

    corporate_id === '' ? common.notifyMessage("Please select corporate") : condition = true;

    if (condition) {
      this.setState({
        spin: true
      });

      this.props.spinnerHandler(true);

      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };
      axios.get(apiConfig.CORPORATE_INVOICE_REPORT({
        corporateId: corporate_id,
        startDate: startDate,
        endDate: endDate,
        branchId: branch_id,
        checkInType: checkInType
      }), {headers: headers})
        .then(async response => {

          if (response.data.success) {
            this.setState({
              totalVisits: response.data.content.totalVisits,
              totalVisitors: response.data.content.totalVisitors,
              isTotal: true,
              visitors_list: response.data.content.allVisitsAndVisitors,
              type: checkInType,
              branch_id_temp: branch_id
            });
          } else {
            this.setState({
              totalVisits: 0,
              totalVisitors: 0,
              isTotal: true,
              visitors_list: []
            });
          }
        })

        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
            this.buttonHandler(start, end);
          }
        })

        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    }
  };

  componentDidMount() {
    if (this.props.usr_obj.userRoles === "SYS_ADMIN") {
      this.getAllDetails();
    } else if (this.props.usr_obj.userRoles === "CORP_ADMIN") {
      this.getAllBranch();
    } else {
      this.buttonHandler();
    }
  }

  render() {
    let {type, branch_id_temp} = this.state;
    let corporate_options = [];
    if (this.state.details.length !== 0) {
      this.state.details.map((details, index) => {
        const obj = {
          key: details.corporateId,
          text: details.corporateName,
          value: details.corporateId
        };
        corporate_options.push(obj)
      })
    }

    let branchDropdownList = [];
    if (this.state.branchList.length !== 0) {
      this.state.branchList.map((value, index) => {
        branchDropdownList.push({
          key: value.branchId,
          text: value.name,
          value: value.branchId
        });
      });
    }

    let rows = [];
    let columns = normal;

    if (this.state.visitors_list.length !== 0) {
      if (type === "VISITOTAGS_CHECKIN" && branch_id_temp === 0) {
        columns = normal_visitor;
        this.state.visitors_list.map((value, index) => {
          rows.push({
            date: value.date,
            branchName: value.branchName,
            subscriptionNumber: value.subscriptionNumber,
            numberOfVisitors: value.visitor,
            numberOfVisits: value.visits
          })
        })
      }
      if (type === "VISITOTAGS_CHECKIN" && branch_id_temp !== 0) {
        columns = hideName_visitor;
        this.state.visitors_list.map((value, index) => {
          rows.push({
            date: value.date,
            subscriptionNumber: value.subscriptionNumber,
            numberOfVisitors: value.visitor,
            numberOfVisits: value.visits
          })
        })
      }
      if (type === "QR_CHECKIN" && branch_id_temp === 0) {
        columns = hideDate;
        this.state.visitors_list.map((value, index) => {
          rows.push({
            branchName: value.branchName,
            numberOfVisitors: value.visitor,
            numberOfVisits: value.visits
          })
        })
      }
      if (type === "QR_CHECKIN" && branch_id_temp !== 0) {
        columns = hideName;
        this.state.visitors_list.map((value, index) => {
          rows.push({
            date: value.date,
            numberOfVisitors: value.visitor,
            numberOfVisits: value.visits
          })
        })
      }
    }

    let data = {columns, rows};
    return (

      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Search Details
              </CardHeader>

              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    {
                      this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                        <Col xs={5}>
                          <LabelDropdown
                            disabled={this.state.spin}
                            tagText={"Corporates"}
                            placeholder={"Select Corporate"}
                            options={corporate_options}
                            value={this.state.corporate_id}
                            onChange={this.corporateHandler("corporate_id")}
                          />
                        </Col> : null
                    }
                    {
                      this.props.usr_obj.userRoles === "CORP_ADMIN" || this.props.usr_obj.userRoles === "SYS_ADMIN" ?
                        <Col xs={4}>
                          <LabelDropdown
                            disabled={this.state.spin}
                            tagText={"Branch"}
                            placeholder={"Select Branch"}
                            options={branchDropdownList}
                            value={this.state.branch_id}
                            onChange={this.branchHandler}
                          />
                        </Col> : null
                    }
                    <Col>
                      <LabelDropdown
                        tagText={"Check-In Type"}
                        placeholder={"Select Type"}
                        options={DropDownConst.checkinTypes}
                        value={this.state.checkInType}
                        onChange={this.corporateHandler("checkInType")}
                      />
                    </Col>
                    <Col xs={3}>
                      <RangePicker
                        className={"rangepicker-super-meeting-report_"}
                        size={"mini"}
                        defaultValue={[moment().subtract(30, "days"), moment().subtract(0, "days")]}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        onChange={this.onChange}
                      />
                    </Col>
                    {
                      this.props.usr_obj.userRoles === "SYS_ADMIN" || this.props.usr_obj.userRoles === "CORP_ADMIN" ?
                        <Col className={"align-right"}>
                          <Button.Group className={"dual-btn-rangepicker-corp-sms-report"}>
                            <Button positive className={"yellow-btn"} onClick={() => this.buttonHandler()}
                                    disabled={this.state.branch_id === ""}>Search</Button>
                          </Button.Group>
                        </Col> : null
                    }

                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                Summary Report History
                <Download data={this.state.visitors_list} userType={"LOGIN_HISTORY"}/>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    {
                      this.state.visitors_list.length !== 0 ?
                        <MDBDataTable
                          id={"history-table"}
                          responsive
                          responsiveSm
                          responsiveMd
                          responsiveLg
                          responsiveXl
                          bordered
                          hover
                          data={data}/>
                        :
                        <div className={"align-center fully-width"}>
                          <Empty description={"Records not found"} className={"empty-icon"}/>
                          <br/>
                        </div>
                    }

                    {
                      this.state.isTotal ?
                        <div style={{marginLeft: "21.7vw"}}>
                          <tr style={{margin: "0", padding: "0", verticalAlign: "baseline", boxSizing: "border-box"}}>
                            <td style={{
                              width: "30vw",
                              height: "6vh",
                              border: "1px solid #dee2e6",
                              padding: "0",
                              verticalAlign: "center",
                              textAlign: "center",
                              fontWeight: "normal",
                              boxSizing: "border-box",
                              font: "inherit",
                              fontSize: "18px",
                              background: "#cbeecb"
                            }}>{"Total Visitors : " + this.state.totalVisitors.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                            &nbsp;&nbsp;
                            <td style={{
                              width: "28vw",
                              height: "6vh",
                              border: "1px solid #dee2e6",
                              padding: "0",
                              verticalAlign: "center",
                              textAlign: "center",
                              fontWeight: "normal",
                              boxSizing: "border-box",
                              font: "inherit",
                              fontSize: "18px",
                              background: "#cbeecb"
                            }}>{"Total Visits : " + this.state.totalVisits.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                          </tr>
                        </div>
                        : null
                    }
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const hideDate = [
  {
    label: "Branch Number",
    field: "branchName",
    sort: "asc"
  },
  {
    label: 'Number Of Visitors',
    field: 'numberOfVisitors',
    sort: 'asc',
    footer: 'Total: '
  },
  {
    label: 'Number Of Visits',
    field: 'numberOfVisits',
    sort: 'asc',

  }
];
const hideName = [
  {
    label: 'Date',
    field: 'date',
    sort: 'asc'
  },
  {
    label: 'Number Of Visitors',
    field: 'numberOfVisitors',
    sort: 'asc',
    footer: 'Total: '
  },
  {
    label: 'Number Of Visits',
    field: 'numberOfVisits',
    sort: 'asc',

  }
];
const normal = [
  {
    label: 'Date',
    field: 'date',
    sort: 'asc'
  },
  {
    label: "Branch Number",
    field: "branchName",
    sort: "asc"
  },
  {
    label: 'Number Of Visitors',
    field: 'numberOfVisitors',
    sort: 'asc',
    footer: 'Total: '
  },
  {
    label: 'Number Of Visits',
    field: 'numberOfVisits',
    sort: 'asc',

  }
];
const normal_visitor = [
  {
    label: 'Date',
    field: 'date',
    sort: 'asc'
  },
  {
    label: "Branch Number",
    field: "branchName",
    sort: "asc"
  },
  {
    label: "Subscription Number",
    field: "subscriptionNumber",
    sort: "asc"
  },
  {
    label: 'Number Of Visitors',
    field: 'numberOfVisitors',
    sort: 'asc',
    footer: 'Total: '
  },
  {
    label: 'Number Of Visits',
    field: 'numberOfVisits',
    sort: 'asc',

  }
];
const hideName_visitor = [
  {
    label: 'Date',
    field: 'date',
    sort: 'asc'
  },
  {
    label: "Subscription Number",
    field: "subscriptionNumber",
    sort: "asc"
  },
  {
    label: 'Number Of Visitors',
    field: 'numberOfVisitors',
    sort: 'asc',
    footer: 'Total: '
  },
  {
    label: 'Number Of Visits',
    field: 'numberOfVisits',
    sort: 'asc',

  }
];
const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
